var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35686 43.5796H41.644C42.1846 43.5795 42.716 43.4391 43.1861 43.1722C43.6563 42.9053 44.0492 42.521 44.3264 42.0569C44.6036 41.5927 44.7556 41.0646 44.7676 40.5241C44.7797 39.9835 44.6512 39.4492 44.3949 38.9731L27.7524 8.06494C26.5717 5.87354 23.4291 5.87354 22.2485 8.06494L5.60589 38.9731C5.34959 39.4492 5.22118 39.9835 5.23319 40.5241C5.24521 41.0646 5.39725 41.5927 5.67445 42.0569C5.95165 42.521 6.34453 42.9053 6.81469 43.1722C7.28486 43.4391 7.81622 43.5795 8.35686 43.5796Z",
    stroke: "#EF9309",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4398 19.0811L25.0004 30.9951L25.5599 19.086C25.5634 19.0098 25.5513 18.9338 25.5244 18.8625C25.4974 18.7912 25.4563 18.7261 25.4033 18.6713C25.3504 18.6165 25.2869 18.573 25.2166 18.5435C25.1463 18.5141 25.0707 18.4993 24.9945 18.5C24.9196 18.5008 24.8457 18.5165 24.777 18.5463C24.7083 18.5761 24.6462 18.6193 24.5945 18.6735C24.5428 18.7276 24.5025 18.7916 24.4759 18.8616C24.4494 18.9316 24.4371 19.0063 24.4398 19.0811Z",
    stroke: "#EF9309",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38.7935C24.6137 38.7935 24.2361 38.6789 23.9149 38.4643C23.5937 38.2497 23.3434 37.9446 23.1955 37.5878C23.0477 37.2309 23.009 36.8382 23.0844 36.4593C23.1598 36.0804 23.3458 35.7324 23.6189 35.4593C23.8921 35.1861 24.2401 35.0001 24.619 34.9247C24.9978 34.8494 25.3905 34.8881 25.7474 35.0359C26.1043 35.1837 26.4094 35.434 26.624 35.7552C26.8386 36.0764 26.9531 36.454 26.9531 36.8403C26.9531 37.3583 26.7474 37.8551 26.3811 38.2214C26.0148 38.5877 25.518 38.7935 25 38.7935Z",
    fill: "#EF9309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.ffed04aa20d1adda65ba49c5f36f4bbd.svg";
export { ForwardRef as ReactComponent };